import { z } from 'zod';
import { grammarPointSchema } from '../schemas';

const getGrammarLessonV1RequestSchemaDefinition = z.object({
  slug: grammarPointSchema.shape.slug.max(80),
});

export const getGrammarLessonV1RequestSchema: typeof getGrammarLessonV1RequestSchemaDefinition =
  getGrammarLessonV1RequestSchemaDefinition;

export type IGetGrammarLessonV1Request = z.infer<typeof getGrammarLessonV1RequestSchema>;
